module.exports = __webpack_public_path__ + "static/img/router.4918d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/router.png
// module id = 156
// module chunks = 1